import { Flex } from '@chakra-ui/react'
import { billingScheduleHomeLoader } from './billingScheduleHome.loader'
import { BillingScheduleHome } from './view/BillingScheduleHome.root'
import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dist/clients/dashboard/v20240730'
import {
  ErrorMessage,
  Modal,
  ModalContextProvider
} from '@sequencehq/core-components'
import { ProductPrice } from 'Products/index'
import { Navigate, useNavigate, useParams } from 'react-router-dom'

const ProductPriceRouteWithLoader = () => {
  const { priceId, id: billingScheduleId } = useParams<{
    priceId: string
    id: string
  }>()
  const navigate = useNavigate()

  const priceQuery = useQuery(
    dashboard20240730Client.getPrice,
    {
      id: priceId as string
    },
    {
      enabled: !!priceId
    }
  )

  if (!priceId || !billingScheduleId) {
    return (
      <ModalContextProvider isOpen>
        <Modal
          variant="drawer"
          onClose={() => {
            if (!billingScheduleId) {
              navigate('/billing-schedules')
              return
            }
            navigate(`/billing-schedules/${billingScheduleId}`)
          }}
        >
          <Flex
            height="100%"
            width="100%"
            alignItems="center"
            justifyContent="center"
          >
            <ErrorMessage />
          </Flex>
        </Modal>
      </ModalContextProvider>
    )
  }

  return (
    <ProductPrice
      onClose={() => {
        navigate(`/billing-schedules/${billingScheduleId}`)
      }}
      price={priceQuery.data}
      showBillingScheduleInfo={false}
    />
  )
}

export const billingScheduleHomeRoutes = [
  {
    path: ':id',
    loader: billingScheduleHomeLoader,
    element: <BillingScheduleHome />,
    children: [
      {
        path: 'price/:priceId',
        element: <ProductPriceRouteWithLoader />
      }
    ]
  },
  {
    path: 'new',
    exact: true,
    element: <Navigate to="/billing-schedules/new/edit?reset=true" />
  }
]
